/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBillingPortalSessionRequest
 */
export interface CreateBillingPortalSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBillingPortalSessionRequest
     */
    returnUrl: string;
}

/**
 * Check if a given object implements the CreateBillingPortalSessionRequest interface.
 */
export function instanceOfCreateBillingPortalSessionRequest(value: object): value is CreateBillingPortalSessionRequest {
    if (!('returnUrl' in value) || value['returnUrl'] === undefined) return false;
    return true;
}

export function CreateBillingPortalSessionRequestFromJSON(json: any): CreateBillingPortalSessionRequest {
    return CreateBillingPortalSessionRequestFromJSONTyped(json, false);
}

export function CreateBillingPortalSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBillingPortalSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'returnUrl': json['returnUrl'],
    };
}

export function CreateBillingPortalSessionRequestToJSON(json: any): CreateBillingPortalSessionRequest {
    return CreateBillingPortalSessionRequestToJSONTyped(json, false);
}

export function CreateBillingPortalSessionRequestToJSONTyped(value?: CreateBillingPortalSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'returnUrl': value['returnUrl'],
    };
}

